import React, { useState } from 'react';
import moment from 'moment';
import parse from 'html-react-parser';
import {
  AccessTime,
  CircleNotifications,
  Close,
  DoneAll,
} from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import './NotificationList.scss';

export type NotificationListProps = {
  notifications: any[];
};

export const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
}) => {
  const { t } = useTranslation();
  const [selectedTask, setSelectedTask] = useState<any>(null);

  const getTaskClickHandler = (task: any) => () => setSelectedTask(task);

  const handleClose = () => setSelectedTask(null);

  const renderFormattedMessage = (n: any) => {
    if (n?.metaData) {
      let m = n.message;

      Object.entries(n.metaData).forEach(([key, value]) => {
        m = m.replace(
          `{{${key}}}`,
          `<span className="text-bold">${
            key.toLowerCase().includes('date')
              ? moment(value as string).format('DD-MM-yyyy hh:mm A')
              : value
          }</span>`,
        );
      });

      return parse(m);
    }

    return n?.message ?? '';
  };

  return (
    <>
      <ul className="notification-list gap-2">
        {notifications.map((notification: any) => (
          <li
            className={`d-flex flex-column notification`}
            key={notification._id}
            onClick={getTaskClickHandler(notification)}
          >
            <div className="d-flex justify-space-between flex-nowrap align-items-center mb-2">
              <span className="name mx-1">
                {renderFormattedMessage(notification)}
              </span>
            </div>

            <div className="d-flex justify-content-between">
              <div>
                <AccessTime fontSize="small" className="icon" />
                <span className="date mx-1">
                  {moment(notification.created_at)
                    .utc(true)
                    .format('DD-MM-yyyy')}
                </span>
              </div>
              <div>
                <CircleNotifications className="icon mx-1" fontSize="small" />
                {notification.hasRead && (
                  <DoneAll className="icon" fontSize="small" />
                )}
              </div>
            </div>
            <div className="left-gutter position-absolute h-100" />
          </li>
        ))}
      </ul>
      {notifications?.length === 0 && (
        <div className="d-flex w-100 h-100 flex-column p-2 align-items-center justify-content-center">
          <div className="no-notification-placeholder-img" />
          <span className="h6">{t('placeholder_no_notifications')}</span>
        </div>
      )}
      <Dialog
        open={!!selectedTask}
        className="open-task-dialog"
        PaperProps={{
          style: {
            padding: 0,
            minWidth: 300,
          },
        }}
        onClose={handleClose}
      >
        <DialogActions className="dialog-actions d-flex justify-content-between w-100">
          <DialogTitle className="p-1" color="inherit">
            {t('label_notifications')}
          </DialogTitle>
          <IconButton className="close-btn" onClick={handleClose}>
            <Close color="inherit" />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <div className="d-flex flex-column mb-2">
            <div className="d-flex flex-column justify-content-between mb-2">
              <span className="form-value h6">
                {renderFormattedMessage(selectedTask)}
              </span>
            </div>
            <div className="d-flex mb-2">
              <div>
                <AccessTime fontSize="small" className="date-icon" />
                <span className="date mx-1 form-value">
                  {moment(selectedTask?.created_at).utc().format('DD-MM-yyyy')}
                </span>
              </div>
            </div>
          </div>
          <div className="d-flex w-100 justify-content-center">
            <Button variant="contained" onClick={handleClose}>
              {t('btn_dismiss')}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
